import script from "./ChatDialogsEmpty.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatDialogsEmpty.vue?vue&type=script&setup=true&lang=ts"

import "./ChatDialogsEmpty.vue?vue&type=style&index=0&id=bf0db6da&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf0db6da"]])

export default __exports__